import { ActionTypesFactory } from "../../common/redux/actions/ActionTypesFactory";

const profilesExportActionTypes = ActionTypesFactory.readActionTypes(
  "PROFILES_EXPORT"
);

export default profilesExportActionTypes;
